export default __webpack_public_path__ + "static/media/Avatar-15.2612de91.svg";